import { render } from "./RiwayatGuru.vue?vue&type=template&id=1b29d30a"
import script from "./RiwayatGuru.vue?vue&type=script&lang=js"
export * from "./RiwayatGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__